var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["search-panel", "j-search-panel", { "is-open": _vm.isPanelOpen }]
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "search-panel__preloader" },
            [_c("PreloaderIcon")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("Filters", {
            attrs: {
              data: _vm.data,
              isMobile: _vm.isMobile,
              isPanelOpen: _vm.isPanelOpen,
              priceChange: _vm.priceChange,
              windowWidth: _vm.windowWidth
            },
            on: {
              closeFilter: _vm.onFilterClose,
              changeFilter: _vm.changeFilter,
              openFilter: _vm.onFilterOpen
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }